/**
 * Corta um texto nos trechos que o servidor mandou destacar.
 *
 * Os trechos chegam como `[início, fim)` sobre o MESMO texto do
 * payload (`core/matching/highlight.py`). Quem renderiza pode ter
 * cortado o texto (o drawer recolhe a matéria em 1.200 caracteres), então
 * os trechos são cortados junto: o que passa do fim do texto some, o que
 * atravessa o fim é aparado.
 *
 * O destaque é o trecho EXATO que casou, nunca a palavra em volta
 * (2026-10-26, decisão da dona): termo sem aspas casa como pedaço de
 * texto, e marcar só "ans" em "transformar" é o que deixa à vista que a
 * sigla ANS casou dentro de outra palavra. Esticar até a palavra inteira
 * (o layout v2 fazia isso) fazia o falso positivo parecer casamento
 * legítimo.
 */

export type Span = [number, number];

export type Segment = { text: string; marked: boolean };

export function splitBySpans(text: string, spans: Span[]): Segment[] {
  const segments: Segment[] = [];
  let cursor = 0;
  for (const [rawStart, rawEnd] of [...spans].sort((a, b) => a[0] - b[0])) {
    const start = Math.max(rawStart, cursor);
    const end = Math.min(rawEnd, text.length);
    if (end <= start) continue;
    if (start > cursor) segments.push({ text: text.slice(cursor, start), marked: false });
    segments.push({ text: text.slice(start, end), marked: true });
    cursor = end;
  }
  if (cursor < text.length) segments.push({ text: text.slice(cursor), marked: false });
  return segments;
}
